import { newTracker, trackPageView, enableActivityTracking, setUserId } from '@snowplow/browser-tracker';
import { enableButtonClickTracking, ButtonClickTrackingPlugin } from '@snowplow/browser-plugin-button-click-tracking';
import { FormTrackingPlugin, enableFormTracking } from '@snowplow/browser-plugin-form-tracking';
import { LinkClickTrackingPlugin, enableLinkClickTracking } from '@snowplow/browser-plugin-link-click-tracking';
import config from '../config';
import { KEY_CHAIN } from '../constants';
export default function TrackSnowPlowEvents (userDetails) {
    newTracker('sp1', config.snowplowCollector, { 
      appId: KEY_CHAIN.SNOW_PLOW_APP_ID, 
      plugins: [ButtonClickTrackingPlugin(), FormTrackingPlugin(), LinkClickTrackingPlugin() ],
    });
    setUserId(userDetails?.userId ?  userDetails.userId : null);
    trackPageView();
    enableButtonClickTracking();
    enableFormTracking({
      options: {
          events: ['submit_form']
      },
    });
    enableLinkClickTracking();
}